<template>
  <div class="container-full">
    <div class="breadcrumbs">
      <div class="container">
        <span v-for="link in paths" :key="link.route_link">
          <router-link :to="link.route_link">
            {{ link.name | htmlDecode }}
          </router-link>
        </span>
        <span class="cl-mine-shaft">
          {{ current | htmlDecode }}
        </span>
      </div>
    </div>
    <script v-if="breadcrumbJsonLd" v-html="breadcrumbJsonLd" type="application/ld+json" />
  </div>
</template>

<script>
import { Breadcrumbs } from '@vue-storefront/core/modules/breadcrumbs/components/Breadcrumbs.ts'
import { localizedRoute, storeCode } from '@vue-storefront/core/lib/multistore'
import i18n from '@vue-storefront/i18n'
import { breadcrumbListJsonLd } from 'theme/helpers/breadcrumbJsonLd'

export default {
  mixins: [Breadcrumbs],
  computed: {
    paths () {
      const routes = this.routes ? this.routes : this.getBreadcrumbsRoutes

      return [
        { name: i18n.t('Home'), route_link: localizedRoute('/', storeCode()) },
        ...routes.filter((e) => e.name !== 'Home')
      ]
    },
    breadcrumbJsonLd () {
      const data = breadcrumbListJsonLd({
        paths: this.paths,
        current: this.current,
        currentPath: this.$route && this.$route.path
      })
      return data ? JSON.stringify(data) : ''
    }
  }
}
</script>
